import { useLocation } from 'react-router-dom';
import Header from '@/components/layout/Header';

const content = {
  privacy: {
    title: 'Privacy',
    sections: [
      ['Information we collect', 'When you place an order, 0middle collects the information needed to process it, including your name, mobile number, delivery address, order details and payment-status information.'],
      ['How we use it', 'We use this information to create and fulfill orders, verify payments, manage inventory, provide customer support and maintain transaction records.'],
      ['Reviews', 'If you submit a product review, we use your order ID and mobile number to verify that the review is linked to a confirmed purchase. Your mobile number is not displayed with the public review.'],
      ['Data access', 'Operational data is available only to authorized 0middle administrators and service providers required to operate the platform.'],
    ],
  },
  terms: {
    title: 'Terms',
    sections: [
      ['Marketplace role', '0middle connects customers with farmer products and provides the transaction and operational workflow. Product information, farmer details, pricing and available inventory are shown on each product page.'],
      ['Orders', 'An order is created when checkout is completed. Stock may be reserved for a limited payment window. An unpaid order can expire and its reserved inventory can return to availability.'],
      ['Payments', 'During the current pilot, UPI payments are manually verified by 0middle. Tapping “I’ve paid” records a customer declaration of payment; the order is treated as paid only after 0middle confirms receipt.'],
      ['Reviews', 'Product reviews are product-specific. A Verified Purchase review requires a confirmed order for the same product and mobile number.'],
    ],
  },
  shipping: {
    title: 'Shipping & cancellations',
    sections: [
      ['Shipping', 'Shipping and handling charges, when applicable, are shown in the price breakdown before the order is placed. Fulfillment information is tied to the specific product and order.'],
      ['Before payment confirmation', 'If payment is not submitted within the reservation window, the order may expire automatically and the reserved stock may become available to another customer.'],
      ['After payment confirmation', 'Cancellation, replacement or refund handling depends on the order status and the condition of the product. Contact 0middle promptly if there is an order issue so it can be reviewed before fulfillment progresses.'],
      ['Damaged or incorrect orders', 'Keep the product and packaging and provide clear photos when reporting a damaged or incorrect order so the issue can be reviewed.'],
    ],
  },
};

const LegalPage = () => {
  const location = useLocation();
  const key =
    location.pathname === '/privacy'
      ? 'privacy'
      : location.pathname === '/shipping-cancellations'
      ? 'shipping'
      : 'terms';
  const selected = content[key];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-semibold">{selected.title}</h1>
        <p className="text-sm text-muted-foreground mt-2">
          0middle public pilot
        </p>

        <div className="space-y-8 mt-8">
          {selected.sections.map(([title, text]) => (
            <section key={title}>
              <h2 className="text-lg font-semibold">{title}</h2>
              <p className="text-muted-foreground mt-2 leading-7">{text}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
